import { render, staticRenderFns } from "./Article35.vue?vue&type=template&id=4fe2f0f8&"
import script from "./Article35.vue?vue&type=script&lang=js&"
export * from "./Article35.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports